import { useEffect } from 'react';
import { userPreferencesPluginKey } from '../pm-plugins/main';
export var useUserPreferencesUpdateListener = function useUserPreferencesUpdateListener(editorView, resolvedUserPreferences) {
  useEffect(function () {
    if (resolvedUserPreferences) {
      editorView.dispatch(editorView.state.tr.setMeta(userPreferencesPluginKey, {
        preferences: resolvedUserPreferences
      }));
    }
  }, [resolvedUserPreferences, editorView]);
};